import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { updateQuickFiltersWithConflictsResolved
// @ts-expect-error migrate upstream dependency
} from '../../../../ducks/quick-filters/quickFilters';
import { resolveDuplicatePropertiesInQuickFilters } from '../../../../lib/dashboardFilters/groupQuickFilterHelpers';

// @ts-expect-error migrate upstream dependency
import { track, EVENTS } from '../../../../../tracking/DashboardUITracker';
import { selectQuickFilterGroups, selectQuickFilters } from '../../../../ducks/quick-filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GenerateQuickFilterConfirmationModal = ({
  handleClose,
  generatedQuickFilterGroups
}) => {
  const dispatch = useDispatch();
  const quickFilters = useSelector(selectQuickFilters);
  const quickFilterGroups = useSelector(selectQuickFilterGroups);
  const handleConfirm = () => {
    const {
      updatedQuickFilterGroups,
      updatedQuickFilters
    } = resolveDuplicatePropertiesInQuickFilters(generatedQuickFilterGroups, quickFilterGroups, quickFilters);
    dispatch(updateQuickFiltersWithConflictsResolved({
      updatedQuickFilterGroups,
      updatedQuickFilters
    }));
    track(EVENTS.confirmResolveDuplicateProperties, {
      actionType: 'explore',
      action: 'confirm-resolve-duplicate-properties',
      assetType: 'dashboard',
      interactionSource: 'dashboard'
    });
    handleClose();
  };
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quickFilter.groupedQuickFilter.generation.confirmationModal.title"
    }),
    description: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.confirmationModal.problemDescription"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.confirmationModal.confirmationDescription"
      })]
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quickFilter.groupedQuickFilter.generation.confirmationModal.confirmButtonLabel"
    }),
    onConfirm: handleConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quickFilter.groupedQuickFilter.generation.confirmationModal.cancelButtonLabel"
    }),
    onReject: () => {
      handleClose();
    },
    size: "auto"
  });
};